import { Images } from 'utils';
import { WidgetEnums } from '../constants';

export const RenderWidgetImage = (type) => {
    switch (type) {
        case WidgetEnums.CLIENT:
            return Images.clientWidget;
        default:
            return Images.clientWidget;
    }
};


